export default __webpack_public_path__ + "i18n/zh-CN.9b096a14465749326c072246db0ee536.json";